import { createWithRemoteLoader } from '@kne/remote-loader';
import { Outlet } from 'react-router-dom';

import logo from './assets/logo.png';
import style from './style.module.scss';

const MainLayout = createWithRemoteLoader({
  modules: ['Global', 'Layout']
})(({ remoteModules, paths, preset, ...props }) => {
  const [Global, Layout] = remoteModules;
  return (
    <Global {...props} preset={preset} className={style['layout-global']}>
      <Layout
        theme={{ '--nav-height': '70px' }}
        navigation={{
          showIndex: false,
          defaultTitle: 'LHH FESCO',
          list: paths,
          headerLogo: {
            id: null,
            src: logo,
            onClick: () => {
              window.location.href = 'https://lhhfesco.com/';
            }
          },
          className: style['layout-navigation-wrap'],
          rightOptions: (
            <span
              className={style['back-to-detail']}
              onClick={() => {
                window.location.href = 'https://lhhfesco.com/career';
              }}
            >
              返回职位列表
            </span>
          )
        }}
      >
        <Outlet />
      </Layout>
    </Global>
  );
});

export default MainLayout;
